import ISymbolTypeGameConfig from "../../vendor_core/core/src/managers/contracts/configurations/game/ISymbolTypeGameConfig";
import AbstractVendorGameGeneralConfig from "../../vendor_core/src/vendorConfigs/AbstractVendorGameGeneralConfig";
import IAdvanceGeneralGameConfig from "../../vendor_core/core/src/managers/contracts/configurations/game/IAdvanceGeneralGameConfig";
import IVendorClientConfigRequestData from "../../vendor_core/src/server/requests/contracts/IVendorClientConfigRequestData";

class GameGeneralConfig
    extends AbstractVendorGameGeneralConfig
    implements IAdvanceGeneralGameConfig<IVendorClientConfigRequestData>
{
    symbolType: ISymbolTypeGameConfig = {
        spine: true,
        standard: false,
        symbol3D: false
    };
    gameType: "cascade" | "normal" = "cascade";
    minWatchTime = 1;
}

export default new GameGeneralConfig();
